import { useBoardCoreData } from '../providers/BoardCoreDataProvider';
export const usePipelineId = () => {
  const {
    pipelineId
  } = useBoardCoreData();
  return pipelineId;
};